import {
    RECALCULATION_INTERVAL_MS,
    TIME_RANGES,
    QUARTER_DAY,
} from './constants.jsx'

export function getDayNightMixValue(timeRef) {
    const now = new Date()
    const currentTime = now.getTime()

    // Check if we need to recalculate (every 15 minutes = 900000 ms)
    if (currentTime - timeRef.current.lastCalculated >= RECALCULATION_INTERVAL_MS) {

        // Current time in minutes
        const hours = now.getHours()
        const minutes = now.getMinutes()
        const currentTimeInMinutes = hours * 60 + minutes

        let mixValue = 0

        // Full day (10H - 16H): mix = 0
        if (currentTimeInMinutes >= TIME_RANGES.day.start && currentTimeInMinutes < TIME_RANGES.day.end) {
            mixValue = 0
        }
        // Evening transition (16H - 22H): mix from 0 to 1
        else if (currentTimeInMinutes >= TIME_RANGES.evening.start && currentTimeInMinutes < TIME_RANGES.evening.end) {
            mixValue = (currentTimeInMinutes - TIME_RANGES.evening.start) / QUARTER_DAY
        }
        // Full night (22H - 04H): mix = 1
        else if (currentTimeInMinutes >= TIME_RANGES.night.start || currentTimeInMinutes < TIME_RANGES.morning.start) {
            mixValue = 1
        }
        // Morning transition (04H - 10H): mix from 1 to 0
        else if (currentTimeInMinutes >= TIME_RANGES.morning.start && currentTimeInMinutes < TIME_RANGES.morning.end) {
            mixValue = 1 - ((currentTimeInMinutes - TIME_RANGES.morning.start) / QUARTER_DAY)
        }

        timeRef.current = {
            lastCalculated: currentTime,
            mixValue: mixValue
        }
    }

    return timeRef.current.mixValue
}